import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import Layout from '../components/Layout';
import ArticlesTable from '../components/ArticlesTable';

const DashboardPage: React.FC = () => {
  return (
    <Layout>
      <Container maxWidth="xl">
        <Box sx={{ mt: 4, mb: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Tableau de Synthèse
          </Typography>
          <ArticlesTable />
        </Box>
      </Container>
    </Layout>
  );
};

export default DashboardPage;
